import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import ActionScreener from "@/modules/action-screens/services/ActionScreener";
import {AfterYouthPlayerScoutingEvent} from "@/modules/youth/event/AfterYouthPlayerScoutingEvent";
import ScoutedCompletedActionScreen from "@/modules/youth/components/ScoutedCompletedActionScreen.vue";

@injectable()
export class ActionScreensEventSubscriber implements EventSubscriber {
  constructor(
    @inject(ActionScreener) private actionScreener: ActionScreener,
  ) {}

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterYouthPlayerScoutingEvent, callback: this.onAfterYouthPlayerScoutingEvent},
    ];
  }

  async onAfterYouthPlayerScoutingEvent(event: AfterYouthPlayerScoutingEvent): Promise<void> {
    if (event.progress > 0 && event.player.isFullyRevealed) {
      await this.actionScreener.show({
        component: ScoutedCompletedActionScreen,
        props: event,
      });
    }
  }
}